import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { hideModal } from '../../services/modal/actions';

import { handleContestEndCookie } from '../../services/giveaway/utils';
import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import ButtonComponent from '../button/ButtonComponent';

import './GiveawayEndModalComponent.scss';

class GiveawayEndModalComponent extends React.Component {
    handleClick = () => {
        handleContestEndCookie();
        this.props.hideModal();
    };

    render() {
        const { i18n } = this.props;

        return (
            <div className="modal-giveaway-end-winners">
                <div className="body">
                    <div className="title">
                        <p>{convertHtmlToReactDomWithParams(i18n.TITLE)}</p>
                    </div>

                    <div className="text-wrapper">
                        <p className="over-border">
                            {convertHtmlToReactDomWithParams(i18n.TEXT_1)}
                        </p>
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT_2)}</p>
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT_3)}</p>
                    </div>

                    <div className="button-wrapper">
                        <ButtonComponent
                            id="close-button"
                            text={i18n.BUTTON_CLOSE}
                            color="main"
                            onClick={this.handleClick}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

GiveawayEndModalComponent.propTypes = {
    i18n: PropTypes.object
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.GIVEAWAY_END_MODAL
    };
};

const mapDispatchToProps = {
    hideModal
};

export default connect(mapStateToProps, mapDispatchToProps)(GiveawayEndModalComponent);



// WEBPACK FOOTER //
// ./src/components/giveaway/GiveawayEndModalComponent.js